//==============================
// Gallery Slider
//==============================

$('.gallery-slider').slick({
  autoplay: true,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  centerPadding: '0'
});
